import React, { useState, useEffect } from "react";
import apiClient from "../../../api/apiClient";
import Loading from "../../../components/Loading/Loading";

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        apiClient
            .get("/admin/stats")
            .then((res) => setStats(res.data))
            .catch(() => setError("Failed to load stats"))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="admin-loading-wrapper"><Loading /></div>;
    if (error) return <p className="admin-empty">{error}</p>;

    const roles = stats?.usersByRole ?? {};

    return (
        <div className="admin-dashboard">
            {/* Users section */}
            <h2 className="admin-dashboard-section-title">Users</h2>
            <div className="admin-stats-grid">
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{stats?.totalUsers ?? 0}</div>
                    <div className="admin-stat-label">Total Users</div>
                </div>
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{roles.user ?? 0}</div>
                    <div className="admin-stat-label">Platform Users</div>
                </div>
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{roles.admin ?? 0}</div>
                    <div className="admin-stat-label">Admins</div>
                </div>
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{roles.superadmin ?? 0}</div>
                    <div className="admin-stat-label">Superadmins</div>
                </div>
            </div>

            {/* Licenses section */}
            <h2 className="admin-dashboard-section-title">Licenses</h2>
            <div className="admin-stats-grid">
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{stats?.totalLicenses ?? 0}</div>
                    <div className="admin-stat-label">Total Licenses</div>
                </div>
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{stats?.realLicenses ?? 0}</div>
                    <div className="admin-stat-label">Real Licenses</div>
                </div>
                <div className="admin-stat-card admin-stat-card--muted">
                    <div className="admin-stat-number">{stats?.testLicenses ?? 0}</div>
                    <div className="admin-stat-label">Test Licenses (MyTEPI)</div>
                </div>
            </div>

            {/* Other */}
            <h2 className="admin-dashboard-section-title">Other</h2>
            <div className="admin-stats-grid">
                <div className="admin-stat-card">
                    <div className="admin-stat-number">{stats?.pendingApprovals ?? 0}</div>
                    <div className="admin-stat-label">Pending Approvals</div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
